import {createAction, props} from '@ngrx/store';

export const selectTab = createAction(
  '[ReportNavigation] Select Tab',
  props<{tab: number}>()
);
export const selectReport = createAction(
  '[ReportNavigation] Select Report',
  props<{report: {code: string, id?: number}}>()
);


export type ReportNavigationActionsUnion = ReturnType<
  typeof selectTab |
  typeof selectReport
  >;
